module.exports = __webpack_public_path__ + "assets/img/m14.ebb4a9e1.png";